import React, { useState, ChangeEvent } from 'react';
import axios from '../axios';
import toast from 'react-hot-toast';
import Seo from './seo';

const Contact = () => {
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        mensagem: ''
    });
    const [value, setValue] = useState('');

    const handleChange = (event: any) => {
        const msg = event.target.value;
        setValue(msg);
        setFormData({ ...formData, mensagem: msg });
    };

    function handleIputChange(event: ChangeEvent<HTMLInputElement>) {
        const { name, value } = event.target;
        setFormData({
            ...formData, [name]: value
        });
    }

    async function sendData() {
        await axios.post('contato', formData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(() => {
                toast.success('Message sent successfully!');
                clear();
            })
            .catch(() => {
                toast.error('Error sending message. Please try again.');
            })
    }

    function clear() {
        setFormData({
            nome: '',
            email: '',
            mensagem: ''
        });
        setValue('');
    }

    return (
        <div className="home-content">
            <Seo
                title="Contato"
                description="Entre em contato com Cesar Castro."
                path="/contact"
            />
            <h1 className="visually-hidden">Contato</h1>
            <div className="terminal-prompt" style={{ width: '100%' }}>
                <span className="terminal-prompt-line">
                    <span className="prompt-user">user</span>
                    <span className="prompt-at">@</span>
                    <span className="prompt-host">cesarcastro</span>
                    <span className="prompt-sep">:</span>
                    <span className="prompt-path">~/contact</span>
                    <span className="prompt-dollar">$</span>
                    <span className="prompt-cmd">send_message --interactive</span>
                    <span className="cursor"></span>
                </span>
            </div>
            <div className="contact">
                <fieldset className="campo">
                    <legend>Nome</legend>
                    <input
                        type="text"
                        autoComplete="off"
                        className="field"
                        name="nome"
                        id="nome"
                        placeholder="your name here..."
                        value={formData.nome}
                        onChange={handleIputChange}
                    />
                </fieldset>
                <fieldset className="campo">
                    <legend>Email</legend>
                    <input
                        type="email"
                        className="field"
                        autoComplete="off"
                        name="email"
                        id="email"
                        placeholder="your@email.com"
                        value={formData.email}
                        onChange={handleIputChange}
                    />
                </fieldset>
                <fieldset className="campo">
                    <legend>Mensagem</legend>
                    <textarea
                        className="field"
                        name="mensagem"
                        id="mensagem"
                        autoComplete="off"
                        placeholder="write your message..."
                        value={value}
                        onBlur={handleChange}
                        onChange={handleChange}
                    />
                </fieldset>
                <div className="buttons">
                    <button className="btn-form-submit" type="button" onClick={sendData}>Send</button>
                    <button className="btn-form-clear" type="button" onClick={clear}>Clear</button>
                </div>
            </div>
        </div>
    )
};

export default Contact;
